/**
 * Get the capture app base URL based on environment.
 */
export function getCaptureUrl(): string {
  if (import.meta.env.VITE_CAPTURE_URL) {
    return import.meta.env.VITE_CAPTURE_URL;
  }

  const hostname = window.location.hostname;

  // Local dev
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:5176";
  }

  // Staging
  if (hostname.includes("staging")) {
    return "https://vizimix-capture-staging.pages.dev";
  }

  // Production
  return "https://vizimix-capture.pages.dev";
}
